import { Box, Image, ImageSourceType, useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';

interface BannerCardProps {
	imageSource?: ImageSourceType | JSX.Element;
	imageAlt?: string;
	imageSize?: number;
	containerStyle?: React.CSSProperties;
}

export const BannerCard: React.FC<BannerCardProps> = ({
	imageSource,
	imageAlt,
	imageSize = 160,
	containerStyle,
	children,
}) => {
	const radius = { borderRadius: containerStyle?.borderRadius || '16px' };
	const { palette } = useTheme();

	return (
		<Box
			styles={{
				...radius,
				backgroundColor: palette.global.ui18,
				boxShadow: '0px 2px 4px #E8EDF2',
				padding: '16px',
				...containerStyle,
			}}
		>
			{imageSource && typeof imageSource === 'string' && (
				<Box
					styles={{
						...radius,
						//backgroundColor: '#C4C4C4',
						// width: imageSize,
						// height: imageSize,
						overflow: 'hidden',
						flexShrink: 0,
						marginRight: 16,
					}}
				>
					<Image alt={imageAlt} source={imageSource} />
				</Box>
			)}
			{imageSource && typeof imageSource === 'object' && <>{imageSource}</>}
			{children}
		</Box>
	);
};
